package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.common.utils.map
import ru.villawonka.app.common.utils.mapLeft
import ru.villawonka.app.domain.model.*
import ru.villawonka.app.domain.repository.PostsRepository

class RequestSearchResultUseCase(private val postsRepository: PostsRepository) {
    private var currentPage = FIRST_PAGE
    private var hasNext = true
    private var lastSearchParams: SearchParamsDomain? = null
    private var lastSortType: SortTypeDomain? = null

    suspend operator fun invoke(
        searchParams: SearchParamsDomain,
        sortType: SortTypeDomain,
        resetPagination: Boolean = false
    ): Either<PaginatedResult.Failure, List<PostDomain.Accommodation>> {
        if (shouldResetPagination(resetPagination, searchParams, sortType)) {
            resetPaginationInternal()
            updateLastParameters(searchParams, sortType)
        }

        return if (!hasNext) {
            Either.Left(PaginatedResult.Failure.NoMoreData)
        } else {
            performSearch(searchParams, sortType)
        }
    }

    private fun shouldResetPagination(
        resetPagination: Boolean,
        searchParams: SearchParamsDomain,
        sortType: SortTypeDomain
    ): Boolean {
        return resetPagination ||
                searchParams != lastSearchParams ||
                sortType != lastSortType
    }

    private suspend fun performSearch(
        searchParams: SearchParamsDomain,
        sortType: SortTypeDomain
    ): Either<PaginatedResult.Failure, List<PostDomain.Accommodation>> {
        return postsRepository.searchByFilter(
            searchParams = searchParams,
            sortType = sortType,
            pageSize = DEFAULT_PAGE_SIZE,
            page = currentPage
        )
            .mapLeft { PaginatedResult.Failure.Network(it) }
            .map { paginatedResult ->
                updatePaginationState(paginatedResult)
                paginatedResult.data
            }
    }

    private fun updatePaginationState(result: PaginatedResult<*>) {
        currentPage = result.currentPage + 1
        hasNext = result.hasNext
    }

    private fun resetPaginationInternal() {
        currentPage = FIRST_PAGE
        hasNext = true
    }

    private fun updateLastParameters(
        searchParams: SearchParamsDomain,
        sortType: SortTypeDomain
    ) {
        lastSearchParams = searchParams
        lastSortType = sortType
    }

    companion object {
        private const val FIRST_PAGE = 1
        private const val DEFAULT_PAGE_SIZE = 25
    }
}